import "./PersonalBonus.scss";
import LevelProfile from "./components/LevelProfile/LevelProfile";
import ProgressLevel from "./components/ProgressLevel/ProgressLevel";
import Bonus from "./components/Bonus/Bonus";
import {useUserStore} from "../../../../../modules/shop/user/store";

const PersonalBonus = () => {
    const user = useUserStore(state => state.user)

    return (
        <>
            <div className="pb">
                <div className="pb-main">
                    <LevelProfile user={user}/>
                    <ProgressLevel user={user} />
                </div>
                <Bonus user={user} />
            </div>
            <p className="pb-note">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <circle cx="12" cy="12" r="9" /><path d="M12 11v5M12 8h.01" />
                </svg>
                <span>кожен пройдений рівень збільшує бонус до поповнення балансу на +1% (максимум 5).</span>
            </p>
        </>
    );
};

export default PersonalBonus;
